export var cilChevronLeftAlt = ["512 512", "<polygon fill='var(--ci-primary-color, currentColor)' points='324.687 451.313 129.373 256 324.687 60.687 347.313 83.313 174.628 256 347.313 428.687 324.687 451.313' class='ci-primary'/>"];
